import styled, { css } from 'styled-components';

import { COLOR_GRAY_30, COLOR_GRAY_90 } from 'styles/variables/colors';
import { MAX_MOBILE } from 'styles/variables/breakpoints';

export const Container = styled.div`
  margin-bottom: 55px;

  @media (max-width: ${MAX_MOBILE}px) {
    margin-bottom: 24px;
  }
`;

export const Anchor = styled.a`
  text-decoration: none;
  color: ${COLOR_GRAY_90};

  &:hover {
    text-decoration: underline;
  }
`;

export const Title = styled.h3`
  margin: 0 0 15px 0;
  font-size: 1.125rem;
  font-weight: bold;
`;

export const ItemImage = styled.img`
  width: 100%;
  object-fit: cover;
  border: 1px solid ${COLOR_GRAY_30};
  padding: 3px;
`;

export const ItemContainer = styled.a`
  width: 100%;
  display: flex;
`;

export const Scroll = styled.div`
  @media (max-width: ${MAX_MOBILE}px) {
    overflow: auto;
  }
`;

export const Grid = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;

  @media (max-width: ${MAX_MOBILE}px) {
    width: 1000px;
  }

  & ${ItemContainer} {
    ${(props) => css`
      width: calc(88% / ${props.columns});
    `}
  }
`;
